import builder from '../builder';
import TaskListText from '../../streamline-icons/light/task-list-text-1.svg';

export default builder('IconTaskListTextLight', TaskListText);
